import { useDroppable } from '@dnd-kit/core';
import type { ReactNode } from 'react';

interface TrackDropZoneProps {
  children: ReactNode;
}

export function TrackDropZone({ children }: TrackDropZoneProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'track-drop-zone',
  });

  return (
    <div ref={setNodeRef} className={`flex-1 min-w-0 self-start transition-[box-shadow] duration-150 ${isOver ? 'ring-2 ring-accent/20 rounded-xl' : ''}`}>
      {children}
    </div>
  );
}
